import { render, staticRenderFns } from "./formstatus.vue?vue&type=template&id=64e99b8a&scoped=true"
import script from "./formstatus.vue?vue&type=script&lang=js"
export * from "./formstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e99b8a",
  null
  
)

export default component.exports